/** @file Radians to degrees (documents hold degrees, math works in radians). */

/** `rad * 180 / pi`. */
export function radToDeg(rad: number): number {
  return (rad * 180) / Math.PI;
}
